export function mapContactFromDto({ id, firstName, lastName, email, businessPhone }) {
    return {
        id,
        firstName,
        lastName,
        name: `${firstName} ${lastName}`.trim(),
        email,
        phone: businessPhone,
    };
}
export function mapContactToContactPerson(contact, type) {
    return {
        type,
        name: contact.name,
        email: contact.email,
        phone: contact.phone,
        contactInformationId: contact.id,
    };
}
/**
 * Rows the user never resolved to a real contact are dropped: Efkt only accepts an existing
 * `contactInformationId`, so a typed-only name has nothing to send.
 */
export function mapContactPersonsToDto(contactPersons = []) {
    return contactPersons
        .filter(contactPerson => !!(contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.contactInformationId))
        .map(({ type, contactInformationId }) => ({
        type,
        contactInformationId: contactInformationId,
    }));
}
